<template>
<div class="uix-panel">
  <div class="uix-panel-header" @click="tooglePanel" :class="{collapsible: collapsible, show: show}">

    <div class="uix-panel-actions">
      <slot name="actions"></slot>
    </div>

    <slot name="header"></slot>
  </div>
  <div class="uix-panel-body" v-if="show">
    <slot></slot>
  </div>
</div>
</template>
<script>
export default {
  props: {
    collapsible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: true
    }
  },
  methods: {
    tooglePanel () {
      if (!this.collapsible) {
        return
      }
      this.show = !this.show
    }
  }
}

</script>


// WEBPACK FOOTER //
// Panel.vue?3a24a976